import { combineReducers } from "redux-immutable"
import showReducer from "highline/redux/admin/reducers/users/show_reducer"

const rootReducer = combineReducers({
  show: showReducer,
})

export default rootReducer
